import { render, staticRenderFns } from "./ButtonToolbarDropdown.vue?vue&type=template&id=1f5ae9cf&"
import script from "./ButtonToolbarDropdown.vue?vue&type=script&lang=js&"
export * from "./ButtonToolbarDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports